import React, { Component } from 'react';
import styled from 'styled-components';
import media from './MediaQueries';
import { translate } from 'react-polyglot';
import goodLight from '../../images/instore/icons/good_light.svg';
import pullBackHair from '../../images/instore/icons/pull_back_hair.svg';
import noMakeup from '../../images/instore/icons/no_makeup.svg';
import neutralFace from '../../images/instore/icons/neutral_face.svg';
import glasses from '../../images/instore/icons/glasses.svg';
import face from '../../images/instore/icons/face.svg';

const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  font-size: 18px;
  font-weight: 300;
  width: 80vw;
  margin-bottom: 150px;
  
  ${media.phone`
    font-size: 12px;
  `}
  
  h1 {
    font-size: 18px;
    font-weight: 300;
    color: white;
    margin-bottom: 30px;
    text-align: center;
    ${media.phone`
      font-size: 12px;
      font-weight: 400;
      margin-bottom: 10px;
    `}
  }
  ul, li {
    list-style: none;
    z-index: 1;
  }
  ul {
    width: 55vw;
    ${media.phone`
      width: 90vw;
    `}
  }
  li {
    color: white;
    text-align: center;
    margin-bottom: 2em;
    width: 100%;
    padding: 0px 10px;
    ${media.phone` 
      margin-bottom: 15px;
    `}
  }
  .withIcons{
    width: 27vw;
    float: left;
    ${media.phone`
      width: 45vw;
    `}
    .icon {
      display: block;
      height: 48px;
      width: 48px;
      margin: 2px auto;
      fill: tomato;
      background-size: contain;
      background-repeat: no-repeat;
      margin-bottom: 5px;
      ${media.phone`
        height: 32px;
        width: 32px;
      `}
    }
  }
  .oddAndLastIcon {
    width: 100%;
  }
  
  .buttonStyle {
    margin-top: 75px;
  }

  .icon {
    display:none;
  }

  .goodLight {
    background-image: url(${goodLight});
  }
  .pullBackHair {
    background-image: url(${pullBackHair});
  }
  .noMakeup {
    background-image: url(${noMakeup});
  }
  .neutralFace {
    background-image: url(${neutralFace});
  }
  .glasses {
    background-image: url(${glasses});
  }
  .face {
    background-image: url(${face});
  }
`

class TakeSelfie extends Component {
  render() {
    const { t, options } = this.props;
    return (
      <StyledDiv className="revieve-instore-introduction">
        {options && options.descriptionText && <h1>{t(options.descriptionText)}</h1>}
        <ul>
          <li className={ options && options.withIcons ? 'withIcons' : ''}><div className="icon glasses"> &nbsp; </div> {t('remove_glasses')} </li>
          <li className={ options && options.withIcons ? 'withIcons' : ''}><div className="icon pullBackHair"> &nbsp; </div> {t('pull_back_hair')} </li>
          <li className={ options && options.withIcons ? 'withIcons' : ''}><div className="icon noMakeup"> &nbsp; </div> {t('Remove your makeup')} </li>
          <li className={ options && options.withIcons ? 'withIcons' : ''}><div className="icon goodLight"> &nbsp; </div> {t('Ensure a good light')} </li>
          <li className={ options && options.withIcons ? 'withIcons' : ''}><div className="icon face"> &nbsp; </div> {t('Face directly at camera')} </li>
          <li className={ options && options.withIcons ? 'withIcons' : ''}><div className="icon neutralFace"> &nbsp; </div> {t('Keep neutral expression')} </li>
        </ul>
      </StyledDiv>
    )
  }
}

export default translate()(TakeSelfie);


// WEBPACK FOOTER //
// ./src/components/instore/SelfieInstructions.js